export const getYouTubeEmbedSrc = (input?: string): string | undefined => {
  if (!input) return undefined;

  try {
    const url = new URL(input);

    // Normalize hostname
    const host = url.hostname.replace(/^www\./, "");

    let videoId: string | null = null;
    let playlistId: string | null = null;

    // Playlist param (works for playlist and watch URLs)
    playlistId = url.searchParams.get("list");

    if (host === "youtu.be") {
      videoId = url.pathname.slice(1);
    }

    if (host.includes("youtube.com")) {
      // Standard watch URL
      if (url.pathname === "/watch") {
        videoId = url.searchParams.get("v");
      }

      // /shorts/{id}
      if (url.pathname.startsWith("/shorts/")) {
        videoId = url.pathname.split("/")[2];
      }

      // /live/{id}
      if (url.pathname.startsWith("/live/")) {
        videoId = url.pathname.split("/")[2];
      }

      // /embed/{id}
      if (url.pathname.startsWith("/embed/")) {
        videoId = url.pathname.split("/")[2];
      }

      // /v/{id}
      if (url.pathname.startsWith("/v/")) {
        videoId = url.pathname.split("/")[2];
      }

      // playlist page
      if (url.pathname === "/playlist" && playlistId) {
        return `https://www.youtube-nocookie.com/embed/videoseries?list=${playlistId}`;
      }
    }

    // Prefer playlist if present (video inside playlist)
    if (playlistId) {
      return `https://www.youtube-nocookie.com/embed/videoseries?list=${playlistId}`;
    }

    if (videoId && /^[a-zA-Z0-9_-]{11}$/.test(videoId)) {
      return `https://www.youtube-nocookie.com/embed/${videoId}`;
    }

    return undefined;
  } catch {
    // Fallback regex extraction if URL constructor fails
    const videoMatch = input.match(
      /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|shorts\/|live\/|embed\/|v\/))([a-zA-Z0-9_-]{11})/,
    );

    if (videoMatch) {
      return `https://www.youtube-nocookie.com/embed/${videoMatch[1]}`;
    }

    const playlistMatch = input.match(/[?&]list=([a-zA-Z0-9_-]+)/);

    if (playlistMatch) {
      return `https://www.youtube-nocookie.com/embed/videoseries?list=${playlistMatch[1]}`;
    }

    return undefined;
  }
};
